export const REGISTER = '/register';
export const AUTOPAY_AGREEMENT = '/portal/autopay/agreement';
export const AUTOPAY_EDIT = '/portal/autopay/edit';
export const AUTOPAY_NEW = '/portal/autopay/new';
export const AUTOPAY_SUCCESS = '/portal/autopay/success';
export const CONTRACT = '/portal/contract';
export const CONTRACT_LIST = '/portal/contracts';
export const CONTRACT_VIEW = '/portal/contracts/:id';
export const CONTRACT_PAYMENTS = '/portal/contracts/:id/payments';
export const DASHBOARD = '/dashboard';
export const DOCUMENTS_NEW = '/portal/documents/upload_center';
export const HARDSHIP = '/portal/requestform';
export const MFA_SETUP = '/portal/mfa/new';
export const MFA_UPDATE_PHONE = '/portal/mfa/phone_number/edit';
export const MFA_VERIFY_PHONE = '/portal/mfa/phone_number';
export const PAYMENTS_NEW = '/portal/payments/new';
export const PAYMENTS_CONFIRM = '/portal/payments/confirm_payment';
export const PAYMENTS_COMPLETED = '/portal/payments/completed_payment';
export const REAPPLY = '/reapply';
export const PORTAL = '/portal';
export const REFER_A_FRIEND = '/portal/refer_friend';
export const REFINANCE = '/refinance';
export const MYREFI = '/myrefi';
export const REFINANCE_INTRO_PAGE = '/refinance/intro';
export const SETTLEMENT_NEW = '/portal/settlement/new';
export const SETTLEMENT_OFFER = '/portal/settlement/offer';
export const SETTLEMENT_OFFER_ACCEPTED = '/portal/settlement/offer_accepted';
export const SETTLEMENT_MANAGE = '/portal/settlement/manage';
export const SETTLEMENT_ALTERNATIVE = '/portal/settlement/alternative_offer';
export const SETTLEMENT_ALTERNATIVE_ACCEPTED =
  '/portal/settlement/alternative_offer_accepted';
export const UPDATE_PROFILE = '/portal/profile/edit';
export const AUTH_MFA_PAGE = '/auth/login/mfa';
export const AUTH_MFA_LOCKED = '/auth/login/mfa/locked';
export const AUTH_MFA_UPDATE_PHONE = '/auth/login/mfa/update_phone';
export const AUTH_SF_LOCKED = '/auth/login/mfa/account_locked';
export const AUTH_LINK_TO_PAY_EXPIRED =
  '/auth/link_to_pay/expired/:shortened_url';

export const AUTH_LOGIN = '/auth/login';
export const AUTH_EMAIL_LOGIN = '/auth/login/email';
export const AUTH_PASSWORD_NEW = '/auth/password/new';
export const AUTH_PASSWORD_SHOW = '/auth/password';
export const AUTH_PASSWORD_EDIT = '/auth/password/edit';
export const AUTH_PASSWORD_RESET_CONFIRMATION =
  '/auth/password/reset_confirmation';
export const AUTH_MAGIC_LINK_LOGIN = '/auth/login/magic_link';
export const AUTH_MAGIC_LINK_LOGIN_RESEND = '/auth/login/magic_link/resend';
export const AUTH_MAGIC_LINK_CONFIRMATION = '/auth/login/magic_link/check';
export const AUTOPAY_ROUTES = [
  AUTOPAY_AGREEMENT,
  AUTOPAY_EDIT,
  AUTOPAY_NEW,
  AUTOPAY_SUCCESS
];

export const CONTRACT_ROUTES = [
  CONTRACT_LIST,
  CONTRACT_VIEW,
  CONTRACT_PAYMENTS
];

export const PAYMENT_ROUTES = [
  PAYMENTS_NEW,
  PAYMENTS_CONFIRM,
  PAYMENTS_COMPLETED
];

export const SETTLEMENT_ROUTES = [
  SETTLEMENT_NEW,
  SETTLEMENT_OFFER,
  SETTLEMENT_OFFER_ACCEPTED,
  SETTLEMENT_MANAGE,
  SETTLEMENT_ALTERNATIVE,
  SETTLEMENT_ALTERNATIVE_ACCEPTED
];

export const REFINANCE_ROUTES = [MYREFI, REFINANCE, REFINANCE_INTRO_PAGE];

export const MFA_ROUTES = [MFA_SETUP, MFA_UPDATE_PHONE, MFA_VERIFY_PHONE];

export const AUTH_ROUTES = [
  AUTH_MFA_PAGE,
  AUTH_MFA_LOCKED,
  AUTH_MFA_UPDATE_PHONE,
  AUTH_SF_LOCKED,
  AUTH_LINK_TO_PAY_EXPIRED,
  AUTH_LOGIN,
  AUTH_PASSWORD_NEW,
  AUTH_PASSWORD_SHOW,
  AUTH_PASSWORD_EDIT,
  AUTH_EMAIL_LOGIN,
  AUTH_PASSWORD_RESET_CONFIRMATION,
  AUTH_MAGIC_LINK_LOGIN,
  AUTH_MAGIC_LINK_LOGIN_RESEND,
  AUTH_MAGIC_LINK_CONFIRMATION
];
